/**
 * Info Popup if Browser is IE, since it is outdated by now
 */
function isIE() {
    const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
    const msie = ua.indexOf('MSIE '); // IE 10 or older
    const trident = ua.indexOf('Trident/'); //IE 11

    return (msie > 0 || trident > 0);
}

function createCookie() {
    var cookieDuration = new Date(new Date().getTime() + 24 * 60 * 60 * 7000);
    setCookie('BrowserPopupCookie-' + identifier, true, cookieDuration);
}

if (isIE()) {
    var identifier = $('.browser-popup').data('identifier');
    var browserPopupCookie = getCookie('BrowserPopupCookie-' + identifier);

    if (!browserPopupCookie) {
        $('.browser-popup').modal('show');

        var modalBox = $('.browser-popup').attr('data-identifier', identifier);
        $(modalBox).find('button').on('click', function () {
            createCookie();
        })
    }
}
